// import React from "react";
// import "../../../../../../css/pages/ca_pages/finances/models/client_payments_model/InvoiceSection.css";

import React from "react";

const InvoiceSection = ({ value, onChange }) => {
    const hasInvoice = Boolean(value);

    return (
        <section className="payment-form-section">
            <div className="section-heading">
                <h3>Invoice</h3>

                <span>
                    Optionally associate this payment request with an existing invoice.
                </span>
            </div>

            <div className="invoice-toggle-card">
                <div className="invoice-toggle-info">
                    <div>
                        <strong>
                            Associate an invoice
                        </strong>

                        <p>
                            Turn this on if this payment request belongs to an invoice already created in your system.
                        </p>
                    </div>

                    <label className="switch">
                        <input
                            type="checkbox"
                            checked={hasInvoice}
                            onChange={(e) => {
                                onChange(e.target.checked ? "" : null);
                            }}
                        />

                        <span className="slider" />
                    </label>
                </div>

                {hasInvoice && (
                    <div className="invoice-selector-area">
                        <label>
                            Invoice
                        </label>

                        <select
                            value={value || ""}
                            onChange={(e) => onChange(e.target.value)}
                        >
                            <option value="">
                                Select an invoice
                            </option>

                            <option value="select-invoice">
                                Invoice selector will be connected here
                            </option>
                        </select>

                        <small className="field-help">
                            We will connect this selector to your existing invoice system.
                        </small>
                    </div>
                )}
            </div>
        </section>
    );
};

export default InvoiceSection;
